import {MessageView} from "../LoadingMessageView/components/MessageView";

export const NoCasesMessageView = () => (
  <MessageView message="沒有案件" />
)